import type {
  FormBuilderStatus,
  FormBuilderVisibility,
} from "@/api/form-builder/formBuilder.types";

const PUBLISHED: FormBuilderStatus = "PUBLISHED";

// Assessment is detected by form type LABEL, not id: lookup ids differ per environment, so an
// id constant would break across environments. This is UX gating only; the server is the source
// of truth and rejects ineligible forms (FORM_NOT_ELIGIBLE_FOR_FALLBACK_DEFAULT).
const isAssessmentType = (label?: string) => label?.trim().toLowerCase() === "assessment";

export interface FallbackDefaultEligibilityInput {
  /** Server-persisted values (formDetail), never unsaved local edits. */
  visibility?: FormBuilderVisibility;
  status?: string;
  formTypeLabel?: string;
  isFallbackDefault: boolean;
}

export interface FallbackDefaultEligibility {
  checked: boolean;
  disabled: boolean;
  reason?: string;
}

export function getFallbackDefaultEligibility({
  visibility,
  status,
  formTypeLabel,
  isFallbackDefault,
}: FallbackDefaultEligibilityInput): FallbackDefaultEligibility {
  let reason: string | undefined;
  if (visibility !== "ALL_TENANTS") {
    reason = "Only forms available to all entities can be the fallback default.";
  } else if (status !== PUBLISHED) {
    reason = "Publish this form to make it the fallback default.";
  } else if (!isAssessmentType(formTypeLabel)) {
    reason = "Only Assessment forms can be the fallback default.";
  } else if (isFallbackDefault) {
    reason = "This form is the fallback default. Mark another form to change it.";
  }
  return { checked: isFallbackDefault, disabled: !!reason, reason };
}
